<div class="flex flex-col w-96 gap-5">
	<div class="flex flex-col rounded-xl bg-grey-lightest gap-2 pb-4">
		<div class="bg-green-lighter rounded">
			<div class="flex justify-between items-center p-3">
				<div class="flex gap-2 items-center text-green-dark font-bold">
					<app-icon [icon]="ICON.DOLLAR"></app-icon>
					<p>Edit direction of total amount</p>
				</div>
				<div class="relative">
					<div class="flex text-sm items-end gap-1">
						<app-anchor (onClick)="toggleShowDefaultInfoMessage()"
							>Default logic</app-anchor
						>
						<app-icon [icon]="ICON.INFO_SQUARE"></app-icon>
					</div>
					<div
						*ngIf="showDefaultInfoMessage"
						class="absolute -bottom-17 -left-64"
						[@openClose]
					>
						<app-doa-message
							(doaMessageClose)="toggleShowDefaultInfoMessage()"
							[showCloseButton]="true"
						></app-doa-message>
					</div>
				</div>
			</div>
		</div>
		<p class="text-orange-darker px-3 text-sm mb-3">
			Please select your preference for direction of title insurance amount
		</p>
		<app-dropdown
			readonly="true"
			class="px-3"
			[ngModel]="directionOfFeeString[location]"
			label="Display amount in"
			[itemGroups]="displayOptions"
			(onSelect)="setDirectionOfAmountLocation($event)"
		></app-dropdown>
		<app-checkbox
			[@openClose]
			*ngIf="location === DirectionOfFeeType.SOA"
			class="px-3 mt-3"
			[@openClose]
			[(ngModel)]="subjectToHSTInSOA"
			label="Subject to HST in Statement of Account"
		></app-checkbox>
	</div>
	<div class="flex flex-col rounded-xl bg-grey-lightest gap-2">
		<div class="bg-green-lighter rounded">
			<div class="flex gap-2 items-center text-green-dark font-bold p-3">
				<app-icon [icon]="ICON.INTEGRATED"></app-icon>
				<p>Edit handling of counsel credit</p>
			</div>
		</div>
		<p class="text-orange-darker px-3 text-sm">
			Please select your preference for handling of counsel credit
		</p>
		<app-radio-group
			[disabled]="disableCounselSettings"
			class="px-3"
			[items]="extendToClientOptions"
			(ngModelChange)="setExtendCredit($event)"
			[ngModel]="extendCreditToClient"
			type="compact"
			label="Extend counsel credit to client"
		></app-radio-group>
		<app-checkbox
			[disabled]="disableCounselSettings"
			[@openClose]
			*ngIf="!extendCreditToClient"
			class="mt-4 px-3 mb-4"
			type="clear"
			[disabled]="extendCreditToClient"
			[ngModel]="combineCounselFee"
			(ngModelChange)="setCombineCounselFee($event)"
			>Combine premium and counsel fee</app-checkbox
		>

		@if (!extendCreditToClient && !combineCounselFee) {
			<app-checkbox
				[disabled]="disableCounselSettings"
				class="px-3 mb-4"
				type="clear"
				[ngModel]="showCounselCredit"
				(ngModelChange)="setShowCounselCredit($event)"
				>Show counsel credit as a fee on the statement of account</app-checkbox
			>
		}
	</div>
	<div class="flex justify-between">
		<app-button size="small" btn="secondary" (onClick)="close()"
			>Cancel</app-button
		>
		<app-button size="small" btn="primary" (onClick)="save()">Save</app-button>
	</div>
</div>
